// Module
var code = "<div ac-treeview=\"$ctrl.config\" ac-treeview-service=\"$ctrl.service\"></div> ";
// Exports
module.exports = code;